/* eslint-disable @typescript-eslint/no-namespace */
export enum ProjectStatus {
  Concept = 1,
  InProgress = 899230000,
  Completed = 2,
}

export enum PossibleUpdates {
  None = 0,
  Owner = 1 << 0,
  Tariff = 1 << 1,
  StartDate = 1 << 2,
  EndDate = 1 << 3,
  DeleteAllowed = 1 << 4,
}

export namespace crmapi {

  export interface Employee {
    employeeId: string;
    name: string;
    startDate?: string;
    endDate?: string;
    um: string[];
  }

  export interface Day {
    taskId: string;
    taskDayId: string;
    day: string;
    plannedHours: number;
    available: number;
  }

  export interface Project {
    projectId: string;
    customer: string;
    projectName: string;
    owner: string;
    status: ProjectStatus;
    startDate: string;
    endDate?: string;
    url: string;
  }

  export interface Week {
    weekNumber: number;
    code: string;
    firstDay: string;
  }

  export interface Task {
    taskId: string;
    name: string;
    categoryKey?: string;
    category: string;
    startDate: string;
    endDate?: string;
    employeeId: string;
    plannedHours: number;
    tariff: number;
    possibleActions: PossibleUpdates;
  }

  export interface CreateUpdateDeleteTaskDay {
    projectTaskDay: Day;
    plannedHours: number;
  }

  export interface ProjectData {
    project: Project;
    categories: string[];
    weeks: Week[];
    tasks: Task[];
    days: Day[];
    employees: Employee[];
    holidays: string[];
  }

}
